import moment from "moment";
export default function ignoreTime(i) {
    return moment(i)
        .set('hour', 0)
        .set('minute', 0)
        .set('second', 0)
        .set('millisecond', 0)
        .toDate();
}
